"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aliases = {
    "mathfrak": "frak",
    "mathcal": "cal",
    "mathbb": "bb",
    "mathbf": "bf",
    "dfrac": "frac",
    "ldots": "dots"
};
//# sourceMappingURL=command-aliases.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/latex-to-unicode-converter/ts-compiled/command-aliases.js
// module id = 95
// module chunks = 0 1 2 3